export function resolveLegacyTarget(pathname = '/') {
  if (!pathname || pathname === '/') {
    return '/';
  }

  const normalized = pathname.replace(/\/+$/, '') || '/';

  if (normalized === '/home' || normalized.startsWith('/home/')) {
    return '/';
  }

  if (normalized === '/vedantacentercharlotte' || normalized === '/vedantacentercharlotte/' || normalized.startsWith('/vedantacentercharlotte/')) {
    const suffix = normalized.replace(/^\/vedantacentercharlotte/, '') || '/';
    if (suffix === '/' || suffix === '/home' || suffix.startsWith('/home/')) {
      return '/';
    }
    if (suffix === '/media' || suffix.startsWith('/media/')) {
      return '/media';
    }
    return '/';
  }

  if (normalized === '/gallery') {
    return '/media';
  }

  const knownPaths = ['/events', '/media', '/lectures', '/books', '/donate', '/contact'];
  if (knownPaths.includes(normalized)) {
    return normalized;
  }

  return '/';
}
